import { Component, OnInit } from '@angular/core';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';
import { ProfilCaisse } from 'src/app/api/model/profil-caisse.model';
import { GestionErreurService } from 'src/app/services/gestion-erreur/gestion-erreur.service';
import { Routes } from 'src/app/models/routes.enum';
import { TelephoneBancaire } from 'src/app/api/model/telephone-bancaire.model';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { ConfigMeta } from 'src/app/models/meta';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { QueryParamsHandling } from '@angular/router';
import { GestionProvenanceService } from '../../services/navigation/gestion-provenance.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpStatusCode } from '@angular/common/http';
import { RequeteCoordonneesBancaireService } from 'src/app/services/requete-coordonnees-bancaire/requete-coordonnees-bancaire.service';
import { ChangementCoordonneeBancaireAccesDService } from 'src/app/services/changement-coordonnee-bancaire-accesd/changement-coordonnee-bancaire-acces-d.service';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { TemplateCoordonneesBancaireEnum } from '../../constantes/template-coordonnees-bancaire.enum';
import { TypeErreurEnum } from '../../constantes/type-erreur.enum';
import { GestionTitreService } from '../../services/navigation/gestion-titre.service';
import { TelephoneTypeLieuEnum } from 'src/app/models/telephone-typelieu.enum';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';

@Component({
  selector: 'app-coordonnees',
  templateUrl: './coordonnees.component.html',
  styleUrls: ['./coordonnees.component.scss'],
  standalone: false,
})
export class CoordonneesComponent implements OnInit {
  readonly templateCoordonneesBancaireEnum = TemplateCoordonneesBancaireEnum;

  cleTraductionPlanifierAppelMobile = 'caad.planifier-appel-page.mobile';
  cleTraductionPlanifierAppelWeb = 'caad.planifier-appel-page.web';

  coordonneesMembre?: ParticulierBancaire;
  pagePlanifierAppelMobile: string = '';
  pagePlanifierAppelWeb: string = '';
  templateAffichageAdresseBancaire = TemplateCoordonneesBancaireEnum.AFFICHER_COORDONNEES_BANCAIRE;
  showModaleSupprimerAdresse: boolean = false;
  postdateeSupprimee: boolean = false;

  constructor(
    private readonly globalStoreService: GlobalStoreService,
    private readonly gestionErreurService: GestionErreurService,
    private readonly gestionProvenanceService: GestionProvenanceService,
    private readonly navigationService: NavigationService,
    private readonly configService: ConfigurationService,
    private readonly gabaritService: GabaritService,
    private readonly translateService: TranslateService,
    private readonly requeteCoordonneesBancaireService: RequeteCoordonneesBancaireService,
    private readonly coordonneesBancaireService: ChangementCoordonneeBancaireAccesDService,
    private readonly gestionTitreService: GestionTitreService,
    private readonly cybermetrieCoordonneesService: CybermetrieCoordonneesService
  ) {}

  ngOnInit(): void {
    this.gestionErreur();
    this.translateService
      .get(this.cleTraductionPlanifierAppelMobile)
      .subscribe((texte: string) => (this.pagePlanifierAppelMobile = texte));
    this.translateService
      .get(this.cleTraductionPlanifierAppelWeb)
      .subscribe((texte: string) => (this.pagePlanifierAppelWeb = texte));
    this.globalStoreService.getCoordonneesMembre$().subscribe({
      next: (data) => {
        this.coordonneesMembre = data;
        this.envoyerEvenementCybermetrie();
      },
    });
    this.gestionTitreService.addTitreOnglet('caad.titreOnglet.page-coordonnees');
  }

  get infoProfilCaisseFolio(): ProfilCaisse[] {
    return this.coordonneesMembre?.adresseCourante?.profilsCaisse ?? [];
  }

  get adressesSpecifiques(): Array<AdressePhysiqueBancaire> {
    return this.coordonneesMembre?.adressesSpecifiques;
  }

  get adresse(): AdressePhysiqueBancaire {
    return this.coordonneesMembre?.adresseCourante;
  }

  get adressePostdatee(): AdressePhysiqueBancaire {
    return this.coordonneesMembre?.adressePostdatee;
  }

  get telephonePrincipal(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones?.find((t) => t.typeLieu === TelephoneTypeLieuEnum.PRINCIPALE);
  }

  get telephoneSecondaire(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones
      ?.filter((t) => t.typeLieu === TelephoneTypeLieuEnum.SECONDAIRE)
      .sort((a, b) => (a.empreinte < b.empreinte ? 1 : -1))[0];
  }

  get telephoneTravail(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones?.find((t) => t.typeLieu === TelephoneTypeLieuEnum.TRAVAIL);
  }

  get courriel(): string {
    return this.coordonneesMembre?.courriel?.adresseCourriel || '';
  }

  get lienCredit(): string {
    return '/' + Routes.CREDIT;
  }

  get lienCreditQueryParamsHandling(): QueryParamsHandling | null {
    return this.gestionProvenanceService.obtenirValeurQueryParamsHandling();
  }

  get libelleAdresseCourante(): string {
    return this.adressePostdatee
      ? 'caad.accueil.vosComptes.libelle.adresseActuelle'
      : 'caad.accueil.vosComptes.libelle.adresse';
  }

  envoyerEvenementCybermetrie(): void {
    if (this.coordonneesMembre !== undefined) {
      const nombre =
        this.infoProfilCaisseFolio.length === 1
          ? this.infoProfilCaisseFolio.at(0).listeFolios.length
          : this.infoProfilCaisseFolio.length;
      this.cybermetrieCoordonneesService.entrerTransactionCoordonneesBancaire(nombre);
    }
  }

  doitAfficherAdressePostdatee(): boolean {
    return this.coordonneesMembre?.adressePostdatee != null && !this.postdateeSupprimee;
  }

  getUrlPlanifierAppel(): string {
    const urlRappel = this.configService.getValueOrBlank(ConfigMeta.OEL_URL_PLANIFIER_APPEL);
    if (this.gabaritService.isAppMobile()) {
      return urlRappel ? urlRappel + this.pagePlanifierAppelMobile : '';
    } else {
      return urlRappel ? urlRappel + this.pagePlanifierAppelWeb : '';
    }
  }

  onClickCoordonneesCredit() {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(CybermetrieEnum.LABEL_BANCAIRE_COORDONNEES_CREDIT);
  }

  onClickAutreProduit(produit: string) {
    this.cybermetrieCoordonneesService.clickModifierCoordonneesAutresProduits(produit);
  }

  onClickPlanifierAppel() {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(CybermetrieEnum.LABEL_BANCAIRE_PLANIFIER_APPEL);
  }

  onClickPlanifierAppelErreur() {
    this.cybermetrieCoordonneesService.clickModifierCoordonneesBancaireErreur(
      CybermetrieEnum.LABEL_BANCAIRE_PLANIFIER_APPEL,
      CybermetrieEnum.MESSAGE_ERREUR_BANCAIRE
    );
  }

  allerAModification() {
    this.cybermetrieCoordonneesService.clickModifierCoordonneesBancaire(CybermetrieEnum.ACTION_ENTREE);
    this.navigationService.naviguerVersModifierCoordonnees();
  }

  private gestionErreur(): void {
    this.globalStoreService.getEtatErreur().subscribe((erreur) => {
      if (erreur) {
        const codeErreur = this.gestionErreurService.getCodeErreur(erreur);
        if (
          this.gestionErreurService.getStatus(erreur) === HttpStatusCode.BadRequest &&
          (codeErreur === TypeErreurEnum.MEMBRE_PROCUREUR ||
            codeErreur === TypeErreurEnum.MAX_FOLIO_BANCAIRE ||
            codeErreur === TypeErreurEnum.ADRESSE_POSTALE_CIVIQUE_DIFFERENTE)
        ) {
          this.templateAffichageAdresseBancaire = TemplateCoordonneesBancaireEnum.ERREUR_NON_DISPONIBLE_MEMBRE;
        } else {
          this.templateAffichageAdresseBancaire = TemplateCoordonneesBancaireEnum.ERREUR_NON_DISPONIBLE;
        }
      }
    });
  }

  private afficherModaleSupressionAdressePostdatee() {
    this.showModaleSupprimerAdresse = true;
  }

  // Arrow functions to preserve "this" context
  public handleConfirmSuppressionAdresse = () => {
    this.cybermetrieCoordonneesService.clickCoordonneesBancaire(CybermetrieEnum.LABEL_BANCAIRE_SUPPRIMER_ADRESSE);
    this.coordonneesBancaireService
      .modifierCoordonnees$(this.requeteCoordonneesBancaireService.construireRequeteSupprimmerPostdatee())
      .subscribe({
        next: () => {
          this.postdateeSupprimee = true;
          this.showModaleSupprimerAdresse = false;
          this.globalStoreService.saveSelector('#confirmationSupression');
          this.coordonneesMembre.adressePostdatee = null;
        },
        error: (err: HttpErrorResponse) => {
          const codeErreur = this.gestionErreurService.getCodeErreur(err);
          this.navigationService.naviguerVersPageErreurCoordonnees(
            err.status.toString(),
            codeErreur,
            this.gestionErreurService.getMessageErreur(err)
          );
        },
      });
  };

  // Arrow functions to preserve "this" context
  public handleCancelSuppressionAdresse = () => {
    this.showModaleSupprimerAdresse = false;
  };
}
